module.exports = __webpack_public_path__ + "img/US_BonusDamagevsHuntable_ua.d9ffd41b.webp";